export const COOKIE_NAME = "creative-elephant-cookie-consent";
